import React from 'react';

import ResetPassword from 'project/Login/ResetPassword';

const ResetPasswordPage = (): JSX.Element => <ResetPassword />;

ResetPasswordPage.hideMenu = true;

export default ResetPasswordPage;
